var _objectSpread = require("D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/objectSpread2").default;
var _objectWithoutProperties = require("D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/objectWithoutProperties").default;
var _excluded = ["class", "staticClass", "style", "staticStyle", "attrs"];
require("core-js/modules/es.array.concat.js");
module.exports = {
  functional: true,
  render: function render(_h, _vm) {
    var _c = _vm._c,
      _v = _vm._v,
      data = _vm.data,
      _vm$children = _vm.children,
      children = _vm$children === void 0 ? [] : _vm$children;
    var classNames = data.class,
      staticClass = data.staticClass,
      style = data.style,
      staticStyle = data.staticStyle,
      _data$attrs = data.attrs,
      attrs = _data$attrs === void 0 ? {} : _data$attrs,
      rest = _objectWithoutProperties(data, _excluded);
    return _c('svg', _objectSpread({
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "width": "20",
        "height": "20",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs)
    }, rest), children.concat([_c('path', {
      attrs: {
        "d": "M9.423 18.531A7.988 7.988 0 015.068 3.848l.02-.01.091-.06.02-.01c.11-.05.221-.081.342-.081.423 0 .775.342.775.774 0 .282-.161.554-.433.704l-.01.01-.01.01a6.394 6.394 0 00-2.886 5.361c0 3.55 2.896 6.447 6.446 6.447s6.447-2.897 6.447-6.447a6.44 6.44 0 00-2.877-5.37l-.02-.01c-.21-.121-.442-.373-.442-.705a.775.775 0 011.116-.694s.02.01.03.02c.03.02.05.03.07.04l.01.01a7.975 7.975 0 013.652 6.709c0 4.405-3.58 7.985-7.986 7.985zm0-6.657a.775.775 0 01-.774-.775V2.22a.775.775 0 011.549 0v8.88a.775.775 0 01-.775.775z",
        "fill": "var(--mainColor)",
        "fill-rule": "nonzero"
      }
    })]));
  }
};